export interface GoodToKnowInfoProps {
  question: string;
  answer: string;
  analytics: string;
}

export const getGoodToKnowInfo: GoodToKnowInfoProps[] = [
  {
    question: 'How does pet insurance work?',
    answer:
      'Lemonade Pet insurance gives you coverage when your pet experiences a new accident or illness, saving you money on unexpected vet bills. Plus, Lemonade Pet offers several preventative packages and add-ons, so you can customize your policy based on your pet’s needs.',
    analytics: 'how_does_pet_insurance_work',
  },
  {
    question: 'What are waiting periods?',
    answer:
      'Like all pet insurers, we have waiting periods before certain coverages kick in - 14 days for illnesses and 30 days for orthopedic conditions. But if you opted for our preventative package, you can use the benefits in that package the day after you purchased the policy!',
    analytics: 'what_are_waiting_periods',
  },
  {
    question: 'What does pet insurance cover?',
    answer:
      'A base accident and illness policy can help cover diagnostics, procedures, medications, and hospitalizations related to new accidents (like broken bones) and illnesses, including hereditary conditions (like hip dysplasia), chronic conditions, infestations, and infections.',
    analytics: 'what_does_pet_insurance_cover',
  },
  {
    question: 'Is pet insurance worth it?',
    answer:
      'Millions of Americans seem to think so! Unforeseen vet bills can add up, which can leave you having to make the difficult decision between your pet’s health and your financial stability. Pet insurance gives you the security of knowing that if the unexpected happens to your pet, you won’t have to drain your savings.',
    analytics: 'is_pet_insurance_worth_it',
  },
  {
    question: 'How much does pet insurance cost?',
    answer:
      'The <a href="https://www.lemonade.com/pet/explained/pet-insurance-cost/" target="_blank">cost of pet insurance</a> plans can vary significantly</a>, depending on factors like breed, age, where you live, and coverages. Getting a quote is the quickest and easiest way to estimate your pet insurance costs.',
    analytics: 'waiting_periods',
  },
  {
    question: 'What are pre-existing conditions and are they covered?',
    answer:
      'Anything your pet has shown signs of before the waiting periods are up is considered a pre-existing condition. Currently, we don’t cover pre-existing conditions, but we’ve got your back in case of accidents and new illnesses, as part of our base care coverage.',

    analytics: 'what_are_pre_existing_conditions_and_are_they_covered',
  },
  {
    question: 'Does Lemonade offer pet insurance near me?',
    answer:
      'Lemonade’s pet insurance is currently available in 42 states, plus Washington, D.C.— <a href="https://www.lemonade.com/lemonade-goes-global" target="_blank">check out where Lemonade Pet (and all our other coverages) are available.</a>',
    analytics: 'does_lemonade_offer_pet_insurance_near_me',
  },
  {
    question: 'How do you compare to other pet insurance companies?',
    answer:
      'To compare pet insurance companies, take a look at what’s covered, how much it costs, how you can customize, and how fast they pay claims. Want a quick breakdown? <a href="https://www.lemonade.com/pet/compare" target="_blank">Check out this comparison guide</a> to see how Lemonade stacks up against the rest.',

    analytics: 'how_do_you_compare_to_other_pet_insurance_companies',
  },
  {
    question: 'How do I add another pet?',
    answer:
      'Each pet needs their own policy, but you’ll be able to list your pets when you sign up and get each <a href="https://www.lemonade.com/pet/dogs" target="_blank">dog</a> or <a href="https://www.lemonade.com/pet/cats" target="_blank">cat</a>. The coverage they need. Plus, by signing up your whole fur fam, you can unlock an automatic multi-pet discount.',
    analytics: 'how_do_i_add_another_pet',
  },
  {
    question: 'Can I go to any vet?',
    answer:
      'You can go to any vet you like in the US. As long as they’re licensed to provide veterinary care in the state they operate in, it’s fair game.',
    analytics: 'can_i_go_to_any_vet',
  },
  {
    question: 'Can I cancel my policy at any time?',
    answer:
      'Yes, you can cancel your policy at any time through the Lemonade app. Keep in mind that our waiting periods will reset, and anything that occurred or was diagnosed during your first policy would be considered pre-existing conditions on a future policy.',
    analytics: 'can_i_cancel_my_policy_at_any_time',
  },
  {
    question: 'How do pet insurance claims work?',
    answer:
      'Lemonade Pet works on a reimbursement basis. You’ll pay the vet bill up front, and then you can immediately file a claim on the Lemonade app. Once it’s approved, we’ll issue a reimbursement directly to your bank account, keeping in mind your deductible and <a href="https://www.lemonade.com/pet/explained/co-insurance/" target="_blank">co-insurance</a>.',
    analytics: 'how_do_pet_insurance_claims_work?',
  },
];
